import type {
  CreateDocumentOptions,
  ExportOptions,
  IAdobeHost,
  PlaceImageOptions,
} from "../host/types";

/** Minimal valid 1x1 transparent PNG (68 bytes) used for mock file reads. */
const MOCK_PNG = new Uint8Array([
  0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a, 0x00, 0x00, 0x00, 0x0d, 0x49,
  0x48, 0x44, 0x52, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x01, 0x08, 0x06,
  0x00, 0x00, 0x00, 0x1f, 0x15, 0xc4, 0x89, 0x00, 0x00, 0x00, 0x0a, 0x49, 0x44,
  0x41, 0x54, 0x78, 0x9c, 0x62, 0x00, 0x00, 0x00, 0x02, 0x00, 0x01, 0xe2, 0x21,
  0xbc, 0x33, 0x00, 0x00, 0x00, 0x00, 0x49, 0x45, 0x4e, 0x44, 0xae, 0x42, 0x60,
  0x82,
]).buffer;

/**
 * Mock host for developing the panel UI in a regular browser without Photoshop.
 * All operations log to the console and return mock values.
 */
export class MockHost implements IAdobeHost {
  readonly appName = "photoshop" as const;

  async createDocument(opts: CreateDocumentOptions): Promise<void> {
    console.log("[MockHost] createDocument", opts);
  }

  async placeImage(localPath: string, opts?: PlaceImageOptions): Promise<void> {
    console.log("[MockHost] placeImage", localPath, opts);
  }

  async exportAsPng(
    outputDir: string,
    filename: string,
    _opts?: ExportOptions,
  ): Promise<string> {
    const path = `${outputDir}/${filename}.png`;
    console.log("[MockHost] exportAsPng →", path);
    return path;
  }

  async saveNativeFile(outputDir: string, filename: string): Promise<string> {
    const path = `${outputDir}/${filename}.psd`;
    console.log("[MockHost] saveNativeFile →", path);
    return path;
  }

  async getTempDirectory(): Promise<string> {
    return "/mock/temp";
  }

  async writeFile(filePath: string, data: ArrayBuffer): Promise<void> {
    console.log("[MockHost] writeFile", filePath, `(${data.byteLength} bytes)`);
  }

  async readFileAsArrayBuffer(_filePath: string): Promise<ArrayBuffer> {
    console.log("[MockHost] readFileAsArrayBuffer", _filePath);
    return MOCK_PNG;
  }

  async hasOpenDocument(): Promise<boolean> {
    return true;
  }

  async getActiveDocumentName(): Promise<string | null> {
    return "Mock Document.psd";
  }
}
